interface MonthlyVisualizationData {
  month: string;
  total_appointments: number;
}

export interface AiVisualization {
  result: {
    data: MonthlyVisualizationData[] | { count: number }[];
    image: string | null;
  };
}

export interface AiVisualizationRequestBody {
  question: string;
  chart_type: VisualizationCharts;
}

export enum VisualizationCharts {
  barChart = "bar chart",
  scatterChart = "scatter plot",
  pieChart = "pie chart",
  lineChart = "line chart",
  areaChart = "area chart",
  table = "table"
}
